// components/MobileNavigation/LoginButton.tsx
import React from 'react';
import { Link } from 'react-router-dom';
// import { UserCheck } from 'lucide-react';

const LoginButton: React.FC = () => {
  return (
    <div className="pt-6 mt-6 border-t border-gray-200">
      <Link
        to="/login"
        className="flex items-center justify-center space-x-2 w-full px-4 py-3 bg-gradient-to-r from-navgreen to-green-600 text-white font-semibold text-base rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95"
      >
        {/* <UserCheck className="w-5 h-5" /> */}
        <span>Login</span>
      </Link>
    </div>
  );
};

export default LoginButton;